/**
 * @generated SignedSource<<52417c88bdbdbcf964dd53d5014dffd1>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ViewInRoom_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ViewInRoomImageCredits_user" | "ViewInRoomImage_user">;
  readonly " $fragmentType": "ViewInRoom_user";
};
export type ViewInRoom_user$key = {
  readonly " $data"?: ViewInRoom_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"ViewInRoom_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ViewInRoom_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoomImage_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ViewInRoomImageCredits_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "33f3c8cb84ee8a8a6d97efecfef2699a";

export default node;
